import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, vModelRadio as _vModelRadio, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/purchase/mastercard.png'
import _imports_1 from '@/assets/img/purchase/paypal.png'
import _imports_2 from '@/assets/img/purchase/bitcoin.png'
import _imports_3 from '@/assets/img/purchase/ethereum.png'
import _imports_4 from '@/assets/img/purchase/web-money.png'
import _imports_5 from '@/assets/img/purchase/ali-pay.png'
import _imports_6 from '@/assets/img/purchase/ideal.png'
import _imports_7 from '@/assets/img/purchase/union-pay.png'
import _imports_8 from '@/assets/img/purchase/lite-coin.png'
import _imports_9 from '@/assets/img/purchase/sofort.png'
import _imports_10 from '@/assets/img/purchase/eps.png'
import _imports_11 from '@/assets/img/purchase/p24.png'


const _withScopeId = n => (_pushScopeId("data-v-6a3ca40b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "checkout" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","justify-content":"center","padding":"20px"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://cdn.proxyscrape.com/img/logo/dark_text_logo.png",
    id: "toplogo",
    alt: "dark proxyscrape logo",
    style: {"margin":"0px !important"}
  })
], -1))
const _hoisted_3 = ["onSubmit"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Checkout")
], -1))
const _hoisted_5 = { id: "redirecting" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader2" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { id: "redirectingtext" }, [
  /*#__PURE__*/_createTextVNode("Redirecting"),
  /*#__PURE__*/_createElementVNode("span", { id: "dots" })
], -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  class: "main",
  id: "checkoutform"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "newuser" }, "Email", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "invalid_mail",
  style: {"display":"none"}
}, "Please provide a valid email address.", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "no_mail",
  style: {"display":"none"}
}, "Please provide your email address.", -1))
const _hoisted_13 = {
  style: {"display":"block","margin-top":"15px"},
  class: "newuser"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode("I accept the ")
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "/terms-and-conditions",
  target: "_blank"
}, "terms and conditions.", -1))
const _hoisted_16 = {
  style: {"display":"block","margin-bottom":"15px"},
  class: "newuser"
}
const _hoisted_17 = /*#__PURE__*/_createTextVNode("I agree to waive my right of withdrawal.")
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "box redBox paddle",
  id: "paddle_unavailable",
  style: {"display":"none"}
}, " Sorry, this payment method is currently unavailable. Please choose another payment method. ", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Select your payment method:", -1))
const _hoisted_20 = { class: "payment-selector" }
const _hoisted_21 = { class: "custom-control custom-radio" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "__BVID__10"
}, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: ""
    }),
    /*#__PURE__*/_createElementVNode("span", null, "Credit Card")
  ])
], -1))
const _hoisted_23 = { class: "custom-control custom-radio" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "__BVID__11"
}, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_1,
      alt: ""
    }),
    /*#__PURE__*/_createElementVNode("span", null, "PayPal")
  ])
], -1))
const _hoisted_25 = { class: "custom-control custom-radio" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "__BVID__12"
}, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_2,
      alt: ""
    }),
    /*#__PURE__*/_createElementVNode("span", null, "Bitcoin")
  ])
], -1))
const _hoisted_27 = { class: "custom-control custom-radio" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "__BVID__13"
}, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_3,
      alt: ""
    }),
    /*#__PURE__*/_createElementVNode("span", null, "Ethereum")
  ])
], -1))
const _hoisted_29 = { class: "custom-control custom-radio" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "__BVID__14"
}, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_4,
      alt: ""
    }),
    /*#__PURE__*/_createElementVNode("span", null, "WebMoney")
  ])
], -1))
const _hoisted_31 = { class: "custom-control custom-radio" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "__BVID__15"
}, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_5,
      alt: ""
    }),
    /*#__PURE__*/_createElementVNode("span", null, "Alipay")
  ])
], -1))
const _hoisted_33 = { class: "custom-control custom-radio" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "__BVID__16"
}, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_6,
      alt: ""
    }),
    /*#__PURE__*/_createElementVNode("span", null, "IDeal")
  ])
], -1))
const _hoisted_35 = { class: "custom-control custom-radio" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "__BVID__17"
}, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_7,
      alt: ""
    }),
    /*#__PURE__*/_createElementVNode("span", null, "Unionpay")
  ])
], -1))
const _hoisted_37 = { class: "custom-control custom-radio" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "__BVID__18"
}, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_8,
      alt: ""
    }),
    /*#__PURE__*/_createElementVNode("span", null, "Litecoin")
  ])
], -1))
const _hoisted_39 = { class: "custom-control custom-radio" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "__BVID__19"
}, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_9,
      alt: ""
    }),
    /*#__PURE__*/_createElementVNode("span", null, "Sofort")
  ])
], -1))
const _hoisted_41 = { class: "custom-control custom-radio" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "__BVID__20"
}, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_10,
      alt: ""
    }),
    /*#__PURE__*/_createElementVNode("span", null, "EPS")
  ])
], -1))
const _hoisted_43 = { class: "custom-control custom-radio" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "__BVID__21"
}, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_11,
      alt: ""
    }),
    /*#__PURE__*/_createElementVNode("span", null, "P24")
  ])
], -1))
const _hoisted_45 = { id: "totalpayment" }
const _hoisted_46 = /*#__PURE__*/_createTextVNode(" Total payment amount: ")
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { key: 1 }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, null, -1))
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "submit-btn" }, "Continue", -1))

import { onMounted, reactive, Ref, ref } from 'vue';
import { useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  props: { totalPrice: String },
  setup(__props) {

const props = __props


const isLoading = ref(false);
const route = useRoute();

const state = reactive({
  email: '',
  terms: false,
  rightsOfwithdrawel: false,
  paymentMethod: '',
  isRedirect: false,
});

onMounted(() => {
  isLoading.value = true;
  setTimeout(() => {
    isLoading.value = false;
  }, 2000);
  state.isRedirect = false;
});

const url: Ref<string> = ref('');

console.log(url);

const checkout = () => {
  state.isRedirect = true;
  setTimeout(() => {
    window.location.href = url.value;
  }, 2000);
};

const onInput = () => {
  if (route.query.type === 'new_datacenter_shared') {
    url.value = `https://api.proxyscrape.com/v2/order/create?email=${state.email}&ref=head&key=&ga_clientid=none&wd_user=&id=&sessionid=&type=${route.query.type}&proxies[${route.query.proxies}]=${route.query.title}&price_version=pt4_2&accept_tac=${state.terms}&lose_right_of_withrawal=${state.rightsOfwithdrawel}&gateway=${state.paymentMethod}`;
  } else if (route.query.type === 'beta_new_residential') {
    url.value = `https://api.proxyscrape.com/v2/order/create?email=${state.email}&ref=head&key=&ga_clientid=none&wd_user=&id=&sessionid=&type=${route.query.type}&bandwidth=${route.query.bandwidth}&price_version=pt4_2&accept_tac=${state.terms}&lose_right_of_withrawal=${state.rightsOfwithdrawel}&gateway=${state.paymentMethod}`;
  } else if (route.query.type === 'beta_new_dedicated') {
    url.value = `https://api.proxyscrape.com/v2/order/create?email=${state.email}&ref=head&key=&ga_clientid=none&wd_user=&id=&sessionid=&type=${route.query.type}&proxies=${route.query.proxies}&price_version=pt4_2&accept_tac=${state.terms}&lose_right_of_withrawal=${state.rightsOfwithdrawel}&gateway=${state.paymentMethod}`;
  }
};

const onChange = () => {
  if (route.query.type === 'new_datacenter_shared') {
    url.value = `https://api.proxyscrape.com/v2/order/create?email=${state.email}&ref=head&key=&ga_clientid=none&wd_user=&id=&sessionid=&type=${route.query.type}&proxies[${route.query.proxies}]=${route.query.title}&price_version=pt4_2&accept_tac=${state.terms}&lose_right_of_withrawal=${state.rightsOfwithdrawel}&gateway=${state.paymentMethod}`;
  } else if (route.query.type === 'beta_new_residential') {
    url.value = `https://api.proxyscrape.com/v2/order/create?email=${state.email}&ref=head&key=&ga_clientid=none&wd_user=&id=&sessionid=&type=${route.query.type}&bandwidth=${route.query.bandwidth}&price_version=pt4_2&accept_tac=${state.terms}&lose_right_of_withrawal=${state.rightsOfwithdrawel}&gateway=${state.paymentMethod}`;
  } else if (route.query.type === 'beta_new_dedicated') {
    url.value = `https://api.proxyscrape.com/v2/order/create?email=${state.email}&ref=head&key=&ga_clientid=none&wd_user=&id=&sessionid=&type=${route.query.type}&proxies=${route.query.proxies}&price_version=pt4_2&accept_tac=${state.terms}&lose_right_of_withrawal=${state.rightsOfwithdrawel}&gateway=${state.paymentMethod}`;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("form", {
      onSubmit: _withModifiers(checkout, ["prevent"]),
      style: {"border-radius":"4px","box-shadow":"0 15px 30px 0 rgb(0 7 3 / 5%)","overflow":"hidden"}
    }, [
      _hoisted_4,
      _withDirectives(_createElementVNode("div", _hoisted_5, _hoisted_8, 512), [
        [_vShow, _unref(state).isRedirect]
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _withDirectives(_createElementVNode("input", {
          class: "newuser",
          type: "email",
          name: "email",
          placeholder: "Email to have product sent to",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).email) = $event)),
          onInput: onInput,
          required: ""
        }, null, 544), [
          [_vModelText, _unref(state).email]
        ]),
        _hoisted_11,
        _hoisted_12,
        _createElementVNode("span", _hoisted_13, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            name: "accept_tac",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).terms) = $event)),
            onChange: onChange,
            required: ""
          }, null, 544), [
            [_vModelCheckbox, _unref(state).terms]
          ]),
          _hoisted_14,
          _hoisted_15
        ]),
        _createElementVNode("span", _hoisted_16, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            name: "lose_right_of_withrawal",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(state).rightsOfwithdrawel) = $event)),
            onChange: onChange,
            required: ""
          }, null, 544), [
            [_vModelCheckbox, _unref(state).rightsOfwithdrawel]
          ]),
          _hoisted_17
        ]),
        _hoisted_18,
        _hoisted_19,
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              name: "gateway",
              class: "custom-control-input",
              value: "credit_card",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(state).paymentMethod) = $event)),
              onChange: onChange,
              id: "__BVID__10",
              required: ""
            }, null, 544), [
              [_vModelRadio, _unref(state).paymentMethod]
            ]),
            _hoisted_22
          ]),
          _createElementVNode("div", _hoisted_23, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              name: "gateway",
              class: "custom-control-input",
              value: "paypal",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(state).paymentMethod) = $event)),
              onChange: onChange,
              id: "__BVID__11",
              required: ""
            }, null, 544), [
              [_vModelRadio, _unref(state).paymentMethod]
            ]),
            _hoisted_24
          ]),
          _createElementVNode("div", _hoisted_25, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              name: "gateway",
              class: "custom-control-input",
              value: "BTC",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(state).paymentMethod) = $event)),
              onChange: onChange,
              id: "__BVID__12",
              required: ""
            }, null, 544), [
              [_vModelRadio, _unref(state).paymentMethod]
            ]),
            _hoisted_26
          ]),
          _createElementVNode("div", _hoisted_27, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              name: "gateway",
              class: "custom-control-input",
              value: "ETH",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(state).paymentMethod) = $event)),
              onChange: onChange,
              id: "__BVID__13",
              required: ""
            }, null, 544), [
              [_vModelRadio, _unref(state).paymentMethod]
            ]),
            _hoisted_28
          ]),
          _createElementVNode("div", _hoisted_29, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              name: "gateway",
              class: "custom-control-input",
              value: "webmoney",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(state).paymentMethod) = $event)),
              onChange: onChange,
              id: "__BVID__14",
              required: ""
            }, null, 544), [
              [_vModelRadio, _unref(state).paymentMethod]
            ]),
            _hoisted_30
          ]),
          _createElementVNode("div", _hoisted_31, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              name: "gateway",
              class: "custom-control-input",
              value: "alipay_cn",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(state).paymentMethod) = $event)),
              onChange: onChange,
              id: "__BVID__15",
              wd_ename: "thisisatest",
              required: ""
            }, null, 544), [
              [_vModelRadio, _unref(state).paymentMethod]
            ]),
            _hoisted_32
          ]),
          _createElementVNode("div", _hoisted_33, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              name: "gateway",
              class: "custom-control-input",
              value: "ideal_nl",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(state).paymentMethod) = $event)),
              onChange: onChange,
              id: "__BVID__16",
              required: ""
            }, null, 544), [
              [_vModelRadio, _unref(state).paymentMethod]
            ]),
            _hoisted_34
          ]),
          _createElementVNode("div", _hoisted_35, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              name: "gateway",
              class: "custom-control-input",
              value: "unionpay_cn",
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(state).paymentMethod) = $event)),
              onChange: onChange,
              id: "__BVID__17",
              required: ""
            }, null, 544), [
              [_vModelRadio, _unref(state).paymentMethod]
            ]),
            _hoisted_36
          ]),
          _createElementVNode("div", _hoisted_37, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              name: "gateway",
              class: "custom-control-input",
              value: "LTC",
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(state).paymentMethod) = $event)),
              onChange: onChange,
              id: "__BVID__18",
              required: ""
            }, null, 544), [
              [_vModelRadio, _unref(state).paymentMethod]
            ]),
            _hoisted_38
          ]),
          _createElementVNode("div", _hoisted_39, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              name: "gateway",
              class: "custom-control-input",
              value: "sofort",
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(state).paymentMethod) = $event)),
              onChange: onChange,
              id: "__BVID__19",
              required: ""
            }, null, 544), [
              [_vModelRadio, _unref(state).paymentMethod]
            ]),
            _hoisted_40
          ]),
          _createElementVNode("div", _hoisted_41, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              name: "gateway",
              class: "custom-control-input",
              value: "eps_at",
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(state).paymentMethod) = $event)),
              onChange: onChange,
              id: "__BVID__20",
              required: ""
            }, null, 544), [
              [_vModelRadio, _unref(state).paymentMethod]
            ]),
            _hoisted_42
          ]),
          _createElementVNode("div", _hoisted_43, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              name: "gateway",
              class: "custom-control-input",
              value: "p24_pl",
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(state).paymentMethod) = $event)),
              onChange: onChange,
              id: "__BVID__21",
              required: ""
            }, null, 544), [
              [_vModelRadio, _unref(state).paymentMethod]
            ]),
            _hoisted_44
          ])
        ]),
        _createElementVNode("div", _hoisted_45, [
          _hoisted_46,
          (!isLoading.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_47, " $" + _toDisplayString(props.totalPrice), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_48, _hoisted_50))
        ]),
        _hoisted_51
      ])
    ], 40, _hoisted_3)
  ]))
}
}

})